import { render } from "./investigations-main.html?vue&type=template&id=14b7291c&scoped=true&ts=true&external"
import script from "./investigations-main.ts?vue&type=script&lang=ts&external"
export * from "./investigations-main.ts?vue&type=script&lang=ts&external"

import "./investigations-main.scss?vue&type=style&index=0&id=14b7291c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b7291c"]])

export default __exports__